// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__vIO0L","footer_nav":"styles_footer_nav__oBKkd"};